import * as Yup from 'yup';
import { DictionarySewerType } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionarySewerType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
